
import { Vue, Component, Watch, Prop, Inject } from "vue-property-decorator";
import {
  API_PATENT_EXPORT,
  API_PATENT_LIST,
  API_PATENT_PATENTEE_SETTING,
  API_PATENT_PATENTEE_LOG,
  API_PATENT_AGENCY_SETTING,
  API_PATENT_AGENCY_LOG,
  API_PATENT_UNFOLLOW,
  API_CUSTOMIZED_CONTENT_SAVE,
  API_PATENT_MANUALADD,
  API_PATENT_MANUALQUERY,
  API_PATENT_DIFF_APPLICANTS_COUNT,
  API_USER_MONITOR_PATENT_INFO
} from "@/configs/Apis";
import { isEmpty, isEmptyOrWhiteSpace, mergeColumns, showConfirm, showError, showSuccess, showWarning, trim } from "@/utils/Common";
import formatters from "@/utils/ColumnFormater";
import { Fetcher as Ajax, Fetcher } from "@/utils/Request";
import {
  MSG_001,
  MSG_EXPORT_FILE_NOTFOUND,
  MSG_INVALID_PAGE
} from "@/configs/Consts";
import commonStore from "@/stores/modules/views/common";

import PatentDetail from "@/views/patent/subviews/PatentDetail.vue";

import {
  QueryEntity, FieldEntity, FieldQueryType,
  DEFAULT_DATE_FIELDS, DEFULT_DATE_QUERY_TYPES, DEFULT_TEXT_FIELDS, DEFULT_DATE_PICKER_OPTIONS
} from "@/entities/PatentQuery";

import CreateOrderDialog from "@/views/patent/subviews/CreateOrderDialog.vue";
import PatentOperatorDialog from "@/views/patent/subviews/PatentOperatorDialog.vue";
import { TableColumn } from "element-ui/types/table-column";
import cloneDeep from "lodash/cloneDeep";
import { MessageBox } from "element-ui";
import ContractBusiness from "@/views/account/components/ContractBusiness.vue";
import DataImporter from "@/views/importer/DataImporter.vue";

@Component({
  components: {
    PatentOperatorDialog,
    CreateOrderDialog,
    PatentDetail,
    DataImporter,
    ContractBusiness
  }
})
export default class Monitor extends Vue {
  @Prop({ type: String, default: () => "VALID" })
  checkedStatus!: string;

  @Prop({ type: String, default: () => "" })
  nodeQueryData!: string;

  @Inject()
  isUserByRegisted!: () => string;

  showRight = false;

  hasSelectedItems = false;

  autoSearchList: Array<string> = [];
  autoSearch: Array<string> = [];
  autoSearchLogList: Array<any> = [];
  autoSearchCheckAll = false;
  authSearchIndeterminate = true;
  showInputDialog = false;

  autoAgencySearchList: Array<any> = [];
  autoAgencySearchLogList: Array<any> = [];
  showAgencyInputDialog = false;

  // addPatentGridEmptyText = "暂无数据（本系统目前仅支持在湖北地区申请的专利）";
  addPatentGridEmptyText = "暂无数据（请稍后重试）";

  diffApplicantsPatentShowGrid = false;
  diffApplicantsPatentQueryStr = "{\"diffApplicants\": true}";
  diffApplicantsPatentGridEmptyText = "暂无数据";

  queryData: QueryEntity = { dateQueryType: "range" };

  patentDetail: any = {};

  queryStr = "";

  filterFromQueryString = "";

  loadData = false;

  dateFields: Array<FieldEntity> = DEFAULT_DATE_FIELDS;
  dateQueryTypes: Array<FieldQueryType> = DEFULT_DATE_QUERY_TYPES;

  feeYearFields: Array<any> = [{ name: "nextFeeYear", label: "待缴年费年度" }, { name: "paidFeeYear", label: "已缴年费年度" }];
  feeYears = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20];

  showSearch = false;

  showNextDetailItem = true;
  showPrevDetailItem = true;
  dataPosition = "";

  // --- create order step 1 vars -- //

  createOrderPatentNos: Array<string> = [];
  showInvoiceAndShippingAddressDialog = false;

  // --- create order step 1 end -- //

  showPatentOperator = false;
  emptyOperatorItem = { id: 0, operationType: [], appFields: [] };
  selectedPatents: Array<any> | null = null;

  diffApplicantCount = 0;

  patentImportVisible = false;

  get canOper() {
    const level = this.$store.getters["user/user"].level;
    return level === "TRIAL" || level === "FORMAL" /** || level === "CHANNEL" */ || level === "VIP" || level === "ULTIMATE" || level === "AGENCY" || level === "ADMIN";
  }

  get canCreateOper() {
    const level = this.$store.getters["user/user"].level;
    return level === "TRIAL" || level === "FORMAL" /** || level === "CHANNEL" */ || level === "VIP" || level === "ULTIMATE" || level === "ADMIN";
  }

  get canAutoMonitorAssignee() {
    const level = this.$store.getters["user/user"].level;
    return level !== "TRIAL" && level !== "AGENCY";
  }

  get canImportByExcel() {
    const userId = this.$store.getters["user/user"].id;
    // enable it for admin or hongguan
    return userId === 1 || userId === 497700944609280;
  }

  get canAutoMonitorAgency() {
    const userId = this.$store.getters["user/user"].id;
    // enable it for admin or hongguan
    return userId === 1 || userId === 497700944609280;
  }

  get isAgency() {
    const level = this.$store.getters["user/user"].level;
    return level === "AGENCY";
  }

  get textFields(): Array<FieldEntity> {
    return JSON.parse(JSON.stringify(DEFULT_TEXT_FIELDS));
  }

  get searchBtnIcon(): string {
    return this.showSearch ? "el-icon-arrow-up" : "el-icon-arrow-down";
  }

  datePickerOptions: any = DEFULT_DATE_PICKER_OPTIONS;

  showCustomizedDialog = false;
  customizedData: any = {
    patentNo: "",
    customizedContent: ""
  };

  // --- ADD PATENT ATTRIBUTES BEGIN--- //
  addPatentQueryStr = "";
  addPatentShowGrid = false;
  addPatentSearchData = {
    patentNo: "",
    agencyName: "",
    patentee: ""
  };

  addPatentShowInputDialog = false;
  addPatentInputMode = "";

  // --- ADD PATENT ATTRIBUTES END--- //

  get dataApi() {
    return API_PATENT_LIST;
  }

  get colFormatters() {
    return formatters;
  }

  createTableColumns() {
    const customizedLabel = this.$store.getters["customized/label"];
    const defaultColumns: Array<TableColumnOption> = [
      { prop: "patentNo", display: "专利号", width: 200, clickable: true },
      { prop: "appDate", display: "申请日", width: 100 },
      { prop: "pubDate", display: "公开(公告)日", width: 140 },
      { prop: "pubNo", display: "公开(公告)号", width: 140 },
      { prop: "title", display: "专利名称", width: 200 },
      { prop: "operationStatus", display: "运营状态", sortable: false, width: 110 },
      { prop: "patentStatus", display: "法律状态", width: 110 },
      { prop: "feeAmount", display: "待缴官费", width: 110 },
      { prop: "feeDate", display: "缴费截止日", width: 130 },
      { prop: "feeStatus", display: "年费状态", width: 120 },
      { prop: "nextFeeYear", display: "待缴年费年度", width: 150 },
      { prop: "paidFeeYear", display: "已缴年费年度", width: 150 },
      // {
      //   prop: 'feeOrderFeeStatus',
      //   display: "委托缴费状态",
      //   sortable: false,
      //   width: 160
      // },
      { prop: "patentee", display: "专利权人", width: 200 },
      { prop: "applicants", display: "申请人", width: 200 },
      { prop: "inventors", display: "发明人", width: 200 },
      { prop: "agencyName", display: "代理机构", width: 200 },
      {
        prop: "customizedContent",
        display: "备注",
        width: 200,
        sortable: false,
        clickable: true
      }
    ];
    this.$store.dispatch("patentmonitor/getListLayout", { listName: "MONITOR" }).then((layout) => {
      const columns = mergeColumns(JSON.parse(layout || "[]"), defaultColumns);
      this.applyColumnFormatters(columns);
      const cusFields = columns.filter(col => col.display === "customizedContent");
      if (cusFields && cusFields.length) {
        cusFields.forEach(field => {
          field.display = customizedLabel;
        });
      }
      return columns;
    }).then((columns) => this.$store.dispatch("patentmonitor/setColumns", columns));
  }

  applyColumnFormatters(columns: Array<TableColumnOption>) {
    const fmers = {
      patentNo: this.colFormatters.formatPatentNo.bind(this),
      feeAmount: (data: any, column: any, value: any) => `<div class="cell-amount">${this.colFormatters.formatAmount(data, column, value)}</div>`,
      feeDate: this.colFormatters.formatFeeOrderDateForList.bind(this),
      feeOrderStatus: this.colFormatters.formatOrderStatus.bind(this),
      feeOrderFeeStatus: this.colFormatters.formatOrderFeeStatus.bind(this),
      patentStatus: this.colFormatters.formatPatentStatus.bind(this),
      feeStatus: this.colFormatters.formatFeeStatus.bind(this),
      lastSyncTime: this.colFormatters.formatLastSyncTime.bind(this),
      operationStatus: this.colFormatters.formatPatentOperator.bind(this),
      customizedContent: (data: any, column: any, value: any) => isEmpty(value) ? "--" : value
    };

    if (!columns || !columns.length) {
      return;
    }

    columns.forEach(option => {
      if (!Object.prototype.hasOwnProperty.call(fmers, option.prop)) {
        return;
      }
      option.formatter = (fmers as any)[option.prop];
    });
  }

  created() {
    this.parseQueryStringParams();
  }

  mounted() {
    this.checkUserLocked();
    this.loadDiffApplicantsCount();
  }

  checkUserLocked() {
    const user = this.$store.getters["user/user"];
    if ((this.isUserByRegisted() || user.level === "AGENCY") && user.locked) {
      const h = this.$createElement;
      MessageBox({
        title: "警告",
        message: h("div", {}, [
          h("span", "您的账户已到期，如需继续使用"),
          h(ContractBusiness),
          h("span", "续费后继续监控")
        ]),
        type: "error"
      });
    }
  }

  loadDiffApplicantsCount() {
    Fetcher.queryData(API_PATENT_DIFF_APPLICANTS_COUNT, {}, "GET").then(cnt => {
      this.diffApplicantCount = cnt || 0;
    }).catch(({ message }) => showError(message));
  }

  openDiffAccountsPanel() {
    if (this.diffApplicantCount === 0) {
      return;
    }
    this.diffApplicantsPatentShowGrid = true;
  }

  parseQueryStringParams() {
    const filter = this.$route.query?.filter as string;
    if (!isEmptyOrWhiteSpace(filter)) {
      this.filterFromQueryString = filter;
      // 去掉参数
      this.$router.replace("monitor");
    }
  }

  onModuleRegistered() {
    this.$nextTick().then(() => this.createTableColumns()).then(() => (this.loadPatentTree(), this.onSearchConditionChange()));
  }

  loadPatentTree() {
    this.$emit("load-tree");
  }

  onTextKeyup() {
    ((this.$refs.searchBtn as Vue).$el as HTMLInputElement).focus();
  }

  onSearchConditionChange() {
    const params: { [key: string]: any } = {};

    if (!isEmptyOrWhiteSpace(this.nodeQueryData)) {
      const nodeFilter = JSON.parse(trim(this.nodeQueryData));
      Object.keys(nodeFilter).forEach(
        name => (params[name] = nodeFilter[name])
      );
    }

    if (!isEmpty(this.queryData.dateField) && !isEmpty(this.queryData.dateQueryType)) {
      if (this.queryData.dateQueryType === "year" && this.queryData.dateQueryYear) {
        const year = this.queryData.dateQueryYear.getFullYear();
        switch (this.queryData.dateField) {
          case "feeDate":
            params.startFeeDate = year + "-01-01";
            params.endFeeDate = year + "-12-31";
            break;
          case "appDate":
            params.startAppDate = year + "-01-01";
            params.endAppDate = year + "-12-31";
            break;
          case "pubDate":
            params.startPubDate = year + "-01-01";
            params.endPubDate = year + "-12-31";
            break;
          default:
        }
      } else if (this.queryData.dateQueryType === "range" && this.queryData.dateQueryRange && this.queryData.dateQueryRange.length === 2) {
        switch (this.queryData.dateField) {
          case "feeDate":
            params.startFeeDate = this.queryData.dateQueryRange[0];
            params.endFeeDate = this.queryData.dateQueryRange[1];
            break;
          case "appDate":
            params.startAppDate = this.queryData.dateQueryRange[0];
            params.endAppDate = this.queryData.dateQueryRange[1];
            break;
          case "pubDate":
            params.startPubDate = this.queryData.dateQueryRange[0];
            params.endPubDate = this.queryData.dateQueryRange[1];
            break;
          default:
        }
      }
    }

    if (!isEmpty(this.queryData.textField) && !isEmpty(this.queryData.keyWord)) {
      if (this.queryData.textField === "all") {
        params.keyWord = this.queryData.keyWord;
      } else {
        params[this.queryData.textField as any] = this.queryData.keyWord;
      }
    }

    if (!isEmpty(this.queryData.feeYearField) && !isEmpty(this.queryData.feeYear)) {
      params[this.queryData.feeYearField as any] = this.queryData.feeYear;
    }

    if (!isEmptyOrWhiteSpace(this.filterFromQueryString)) {
      const query = JSON.parse(this.filterFromQueryString);
      if (Reflect.has(query, "startFeeDate")) {
        params.startFeeDate = query.startFeeDate;
        params.endFeeDate = query.endFeeDate;
      }
      if (Reflect.has(query, "feeStatus")) {
        params.feeStatus = query.feeStatus;
      }
    }

    if (isEmpty(params.patentStatus)) {
      params.patentStatus = this.checkedStatus;
    }

    const paramsStr = JSON.stringify(params);
    if (paramsStr === "{}" && this.queryStr.trim() === "") {
      return;
    }

    if (paramsStr !== this.queryStr.trim()) {
      this.queryStr = JSON.stringify(params);
    }
  }

  @Watch("nodeQueryData")
  @Watch("checkedStatus")
  onNodeQueryDataChange() {
    if (!isEmptyOrWhiteSpace(this.filterFromQueryString)) {
      this.filterFromQueryString = "";
    }
    this.queryData = { dateQueryType: "range" };
    this.onSearchConditionChange();
  }

  @Watch("queryData.dateField")
  @Watch("queryData.textField")
  @Watch("queryData.feeYearField")
  @Watch("queryData.dateQueryType")
  onSeachPanelConditionChange() {
    if (!isEmptyOrWhiteSpace(this.filterFromQueryString)) {
      this.filterFromQueryString = "";
    }
    this.onSearchConditionChange();
  }

  searchData() {
    if (!isEmptyOrWhiteSpace(this.filterFromQueryString)) {
      this.filterFromQueryString = "";
      this.onSearchConditionChange();
      return;
    }
    if (this.queryStr.endsWith(" ")) {
      this.queryStr = this.queryStr.trim();
    } else {
      this.queryStr += " ";
    }
  }

  addPatent(cmd: string) {
    if (this.$store.getters["user/user"].locked) {
      showWarning("当前账户已锁定，您可以在解除锁定后进行后续操作");
      return;
    }

    if (cmd === "auto") {
      this.addAutoSearch();
      return;
    }

    if (cmd === "autoAgency") {
      this.addAutoSearchAgency();
      return;
    }

    if (cmd === "excel") {
      this.patentImportVisible = true;
      return;
    }

    this.$store.dispatch("patentmonitor/get", { api: API_USER_MONITOR_PATENT_INFO })
      .then((rs: any) => {
        if (rs.monitorLimit > 0 && rs.monitorCount >= rs.monitorLimit) {
          showWarning(`您目前累积添加的专利数量已超过 ${rs.monitorLimit}，请联系管理员`);
          return;
        }
        this.showPatentNoDialog(cmd);
      })
      .catch(({ message }) => showError(message));
  }

  addAutoSearch() {
    this.showInputDialog = true;
  }

  addAutoSearchAgency() {
    this.showAgencyInputDialog = true;
  }

  unfollow(cmd: string) {
    let params: any = {};
    let message = "是否将<span style='color:red;font-weight: 600'>全部</span>专利放入回收站?";
    if (cmd === "selected") {
      const selectedRows = (this.$refs.monitorgrid as any).getSelectedRows();
      if (!selectedRows || selectedRows.length === 0) {
        showWarning("请至少选择一条数据");
        return;
      }

      params.selectedNos = selectedRows;
      message = `是否将选择的 ${selectedRows.length} 条专利放入回收站?`;
    } else {
      if (!isEmptyOrWhiteSpace(this.queryStr)) {
        params = JSON.parse(this.queryStr);
      }
    }
    showConfirm("<font color=red>回收站的专利将不再进行监控！</font><br>" + message)
      .then(() => {
        this.$store.dispatch("patentmonitor/post", {
          api: API_PATENT_UNFOLLOW,
          params: params
        }).then(() => showSuccess("停止监控成功"))
          .then(() => (this.loadPatentTree(), this.searchData(), this.loadDiffApplicantsCount()))
          .catch(({ message }) => showError(message));
      }).catch(() => "");
  }

  unfollowDiffApplicants(cmd: string) {
    let params: any = {};
    let message = "是否将<span style='color:red;font-weight: 600'>全部</span>专利放入回收站?";
    if (cmd === "selected") {
      const selectedRows = (this.$refs.diffapplicantsgrid as any).getSelectedRows();
      if (!selectedRows || selectedRows.length === 0) {
        showWarning("请至少选择一条数据");
        return;
      }

      params.selectedNos = selectedRows;
      message = `是否将选择的 ${selectedRows.length} 条专利放入回收站?`;
    } else {
      params = {diffApplicants: true};
    }
    showConfirm("<font color=red>回收站的专利将不再进行监控！</font><br>" + message)
      .then(() => {
        this.$store.dispatch("patentmonitor/post", {
          api: API_PATENT_UNFOLLOW,
          params: params
        }).then(() => showSuccess("停止监控成功"))
          .then(() => (this.closeDiffApplicantsPatentDialog(), this.loadPatentTree(), this.searchData(), this.loadDiffApplicantsCount()))
          .catch(({ message }) => showError(message));
      }).catch(() => "");
  }

  onAgencyInputDialogOpen() {
    this.autoAgencySearchList = [];
    this.autoAgencySearchLogList = [];

    this.reloadAutoAgency();
    this.reloadAutoAgencyLog();
  }

  onInputDialogOpen() {
    this.autoSearchList = [];
    this.autoSearch = [];
    this.autoSearchLogList = [];

    this.reloadAuto();
    this.reloadAutoLog();
  }

  handleAutoSearchCheckAllChange(val: boolean) {
    this.autoSearch = val ? this.autoSearchList : [];
    this.authSearchIndeterminate = false;
  }

  handleAuthSearchCheckedChange(value: any) {
    const checkedCount = value.length;
    this.autoSearchCheckAll = checkedCount === this.autoSearchList.length;
    this.authSearchIndeterminate = checkedCount > 0 && checkedCount < this.autoSearchList.length;
  }

  reloadAuto() {
    this.$store.dispatch("patentmonitor/get", { api: `${API_PATENT_PATENTEE_SETTING}?_=${Math.random().toString().replace(/\D/g, "")}` }).then(data => {
      const patenteeList: Array<any> = data || [];
      patenteeList.forEach((patentee) => {
        this.autoSearchList.push(patentee.patentee);
        if (patentee.id && patentee.id > 0) {
          this.autoSearch.push(patentee.patentee);
        }
      });
    });
  }

  reloadAutoLog() {
    this.autoSearchLogList = [];
    this.$store.dispatch("patentmonitor/post", {
      api: API_PATENT_PATENTEE_LOG,
      params: {
        page: 0,
        pageSize: 50
      }
    }).then(data => {
      this.autoSearchLogList = data.data || [];
    });
  }

  submitAuto() {
    const params = this.autoSearch;
    return this.$store.dispatch("patentmonitor/post", {
      api: API_PATENT_PATENTEE_SETTING,
      params: params
    })
      .then(() => showSuccess("保存成功"))
      .catch(({ message }) => showError(message));
  }

  reloadAutoAgency() {
    this.$store.dispatch("patentmonitor/get", { api: `${API_PATENT_AGENCY_SETTING}?_=${Math.random().toString().replace(/\D/g, "")}` }).then(data => {
      this.autoAgencySearchList = data || [];
      if (this.autoAgencySearchList.length === 0) {
        this.autoAgencySearchList.push({ agency: "" });
      }
    });
  }

  addAutoAgencyRow(idx: number) {
    const user = this.$store.getters["user/user"];
    if (user.level === "AGENCY" && this.autoAgencySearchList.length >= 3) {
      showWarning("目前最多允许添加三条记录");
      return;
    }
    this.autoAgencySearchList.splice(idx + 1, 0, {
      agency: ""
    });
  }

  deleteAutoAgencyRow(idx: number, agency: string) {
    // if (this.autoAgencySearchList.length === 1) {
    //   showError("请至少保留一条数据");
    //   return;
    // }
    showConfirm(`确认删除 ${agency} ？`)
      .then(() => {
        this.autoAgencySearchList.splice(idx, 1);
      })
      .catch(() => "");
  }

  reloadAutoAgencyLog() {
    this.autoAgencySearchLogList = [];
    this.$store.dispatch("patentmonitor/post", {
      api: API_PATENT_AGENCY_LOG,
      params: {
        page: 0,
        pageSize: 50
      }
    }).then(data => {
      this.autoAgencySearchLogList = data.data || [];
    });
  }

  submitAutoAgency() {
    const params = this.autoAgencySearchList;
    return this.$store.dispatch("patentmonitor/post", {
      api: API_PATENT_AGENCY_SETTING,
      params: params
    })
      .then(() => showSuccess("保存成功"))
      .catch(({ message }) => showError(message));
  }

  submitCustomizedContent() {
    const params = {
      patentNo: this.customizedData.patentNo,
      customizedContent: this.customizedData.customizedContent
    };
    return this.$store.dispatch("patentmonitor/post", {
      api: API_CUSTOMIZED_CONTENT_SAVE,
      params: params
    })
      .then(() => showSuccess("保存成功"))
      .then(() => this.showCustomizedDialog = false)
      .then(() => Promise.all([this.searchData()]))
      .catch(({ message }) => showError(message));
  }

  async createOrder() {
    if (this.$store.getters["user/user"].locked) {
      showWarning("当前账户已锁定，您可以在解除锁定后进行后续操作");
      return;
    }

    const selectedRows = (this.$refs.monitorgrid as any).getSelectedRows();
    if (!selectedRows || selectedRows.length === 0) {
      showWarning("请至少选择一条数据");
      return;
    }
    try {
      await this.$store.dispatch("userorder/createOrder", { patentNos: selectedRows });
      await this.$router.push({ name: "userorder" });
    } catch (e:any) {
      await showError(e.message);
    }
  }

  createPatentOperator() {
    const selectedRows = (this.$refs.monitorgrid as any).getSelectedDataRows();
    if (!selectedRows || selectedRows.length === 0) {
      showWarning("请至少选择一条数据");
      return;
    }
    this.selectedPatents = cloneDeep(selectedRows);
    (this.selectedPatents as any).forEach((patent: any) => {
      patent.patentType = this.colFormatters.formatPatentTypeOnlyText(
        null,
        null,
        patent.patentType
      );
      if (patent.patentStatus === "VALID") {
        patent.patentStatus = "授权已下证";
      } else if (patent.patentStatus === "INTRIAL") {
        patent.patentStatus = "审查中";
      } else if (patent.patentStatus === "INVALID") {
        patent.patentStatus = "已失效";
      } else {
        patent.patentStatus = "";
      }
    });
    this.showPatentOperator = true;
  }

  exportData(cmd: string) {
    let params: any = {};
    if (cmd === "selected") {
      const selectedRows = (this.$refs.monitorgrid as any).getSelectedRows();
      if (!selectedRows || selectedRows.length === 0) {
        showWarning("请至少选择一条数据");
        return;
      }

      params.selectedNos = selectedRows;
    } else {
      if (!isEmptyOrWhiteSpace(this.queryStr)) {
        params = JSON.parse(this.queryStr);
      }
    }
    params.exportFields = JSON.parse(JSON.stringify((this.$refs.monitorgrid as any).columns || []));
    params.exportFields.forEach((f: any) => {
      f.width = parseInt(f.width || 0);
    });
    Fetcher.queryData(API_PATENT_EXPORT, params).then(url => {
      if (isEmpty(url)) {
        showWarning(MSG_EXPORT_FILE_NOTFOUND);
        return;
      }
      const a = document.createElement("a");
      a.setAttribute("href", url);
      a.setAttribute("target", "_blank");
      document.body.appendChild(a);
      a.click();
      if (a.parentNode) {
        a.parentNode.removeChild(a);
      }
    }).catch(({ message }) => showError(message));
  }

  onSelectionChanged(selectedRows: any[]) {
    this.hasSelectedItems = selectedRows.length > 0;
  }

  onRowClick(command: string, data: any, event: MouseEvent) {
    if (command === "patentNo") {
      if (event.stopPropagation) {
        event.stopPropagation();
      } else {
        event.cancelBubble = true;
      }
      this.showRight = true;
      this.showPrevDetailItem = true;
      this.showNextDetailItem = true;

      this.patentDetail = JSON.parse(JSON.stringify(data));
      const grid = this.$refs.monitorgrid as any;
      const dataIndex = grid.tableData.findIndex((item: any) => item.id === data.id);
      if (grid.isFirstPage() && dataIndex === 0) {
        this.showPrevDetailItem = false;
      }
      if (grid.isLastPage() && dataIndex === grid.tableData.length - 1) {
        this.showNextDetailItem = false;
      }
    } else if (command === "customizedContent") {
      this.customizedData = {
        patentNo: data.patentNo,
        customizedContent: data.customizedContent
      };
      this.showCustomizedDialog = true;
    }
  }

  hideFloater() {
    this.showRight = false;
  }

  onColumnConfiged({
    data = [],
    hidden = []
  }: { data: Array<TableColumnOption>, hidden: Array<TableColumnOption> }) {
    const newData: Array<TableColumnOption> = JSON.parse(JSON.stringify(data));
    const newHidden: Array<TableColumnOption> = JSON.parse(JSON.stringify(hidden));
    // 删除属性
    newData.forEach(item => delete item.hidden);

    if (hidden && hidden.length) {
      newData.push(...newHidden.map(val => Object.assign(val, { hidden: true })));
    }

    this.$store.dispatch("patentmonitor/saveListLayout", {
      listName: "MONITOR",
      layout: JSON.stringify(newData)
    })
      .then(() => this.$store.dispatch("patentmonitor/setColumns", []))
      .then(() => this.createTableColumns()).catch(({ message }) => showError(message));
  }

  onColumnResize(newWidth: number, column: TableColumn) {
    this.$store.dispatch("patentmonitor/setColumnWidth", {
      listName: "MONITOR",
      column: column.property,
      newWidth
    });
  }

  openColumnConfig() {
    const grid = this.$refs.monitorgrid as any;
    grid.openColumnConfig();
  }

  onTableDataLoaded() {
    if (this.showRight && !isEmptyOrWhiteSpace(this.dataPosition)) {
      this.patentDetail = null;
      if (this.dataPosition === "Prev") {
        this.onNextDataItem();
      } else if (this.dataPosition === "Next") {
        this.onPrevDataItem();
      }
    }
  }

  onNextDataItem() {
    if (!this.showRight) {
      return;
    }

    this.dataPosition = "Next";

    const grid = this.$refs.monitorgrid as any;
    const data = grid.tableData;

    if (data.length === 0) {
      return;
    }

    let currentItem = this.patentDetail;
    let nextIndex;
    const lastIndex = data.length - 1;

    if (!currentItem) {
      currentItem = data[lastIndex];
      nextIndex = lastIndex;
    } else {
      const index = data.findIndex((item: any) => item.id === currentItem.id);
      nextIndex = index + 1;
      if (index === -1 || nextIndex > lastIndex && !grid.isLastPage()) {
        grid.setPageIndex(grid.pageIndex + 1);
        return;
      }
      currentItem = data[nextIndex];
    }

    this.showPrevDetailItem = true;
    this.showNextDetailItem = true;

    if (grid.isFirstPage() && nextIndex <= 0) {
      this.showPrevDetailItem = false;
    }

    if (grid.isLastPage() && nextIndex >= lastIndex) {
      this.showNextDetailItem = false;
    }

    grid.setCurrentDataRow(currentItem);
    this.patentDetail = JSON.parse(JSON.stringify(currentItem));
  }

  onPrevDataItem() {
    if (!this.showRight) {
      return;
    }

    this.dataPosition = "Prev";

    const grid = this.$refs.monitorgrid as any;
    const data = grid.tableData;
    let currentItem = this.patentDetail;
    let prevIndex;

    if (!currentItem) {
      currentItem = data[0];
      prevIndex = 0;
    } else {
      const index = data.findIndex((item: any) => item.id === currentItem.id);
      prevIndex = index - 1;
      if ((index === -1 || prevIndex < 0) && !grid.isFirstPage()) {
        grid.setPageIndex(grid.pageIndex - 1);
        return;
      }
      currentItem = data[prevIndex];
    }

    this.showPrevDetailItem = true;
    this.showNextDetailItem = true;

    if (grid.isFirstPage() && prevIndex === 0) {
      this.showPrevDetailItem = false;
    }

    if (grid.isLastPage() && prevIndex === data.length - 1) {
      this.showNextDetailItem = false;
    }

    grid.setCurrentDataRow(currentItem);
    this.patentDetail = JSON.parse(JSON.stringify(currentItem));
  }

  // --- ADD PATENT METHOD BEGIN --- //
  get validateRules() {
    return {
      patentNo: {
        required: true,
        message: "请输入申请号/公开(公告)号",
        trigger: "blur"
      },
      agencyName: {
        required: true,
        message: "请输入代理机构",
        trigger: "blur"
      }
    };
  }

  get addPatentDataApi() {
    return API_PATENT_MANUALQUERY;
  }

  showPatentNoDialog(mode: string) {
    this.addPatentInputMode = mode;
    this.addPatentShowInputDialog = true;
  }

  onCloseAddPatentDialog() {
    this.$store.unregisterModule("addpatent");
  }

  closeAddPatentDialog() {
    this.addPatentShowGrid = false;
  }

  onOpenAddPatentDialog() {
    this.$store.registerModule("addpatent", commonStore);

    const patentType = this.$store.getters["enums/getEnumsByKey"]("PatentType");
    const map1: { [key: string]: any } = {};
    if (patentType && patentType.length) {
      patentType.forEach((data: any) => {
        map1[data.enumValue] = data.label;
      });
    }
    const patentStatus = this.$store.getters["enums/getEnumsByKey"]("PatentStatus");
    const map2: { [key: string]: any } = {};
    if (patentStatus && patentStatus.length) {
      patentStatus.forEach((data: any) => {
        map2[data.enumValue] = data.label;
      });
    }
    const columns: Array<TableColumnOption> = [
      {
        prop: "patentNo",
        display: "专利号",
        width: 210,
        formatter: (data: any, column: any, value: any) => {
          return this.colFormatters.formatPatentNo(data, column, value, false);
        },
        sortable: false
      },
      {
        prop: "title",
        display: "名称",
        width: 200,
        sortable: false
      },
      {
        prop: "appDate",
        display: "申请日",
        width: 110,
        sortable: false
      },
      {
        prop: "pubNo",
        display: "公开(公告)号",
        width: 130,
        sortable: false
      },
      {
        prop: "pubDate",
        display: "公开(公告)日",
        width: 130,
        sortable: false
      },
      {
        prop: "patentStatus",
        display: "法律状态",
        width: 120,
        sortable: false,
        formatter: (data: any, column: any, value: any) => {
          return this.colFormatters.formatPatentStatus(data);
        }
      },
      {
        prop: "patentee",
        display: "专利权人",
        width: 200,
        sortable: false
      },
      {
        prop: "applicants",
        display: "申请人",
        width: 200,
        sortable: false
      },
      // {prop: 'applicantAddress', display: "地址", width: 200, sortable: false},
      {
        prop: "inventors",
        display: "发明人",
        width: 200,
        sortable: false
      },
      {
        prop: "agencyName",
        display: "代理机构",
        width: 200,
        sortable: false
      },
      {
        prop: "agentName",
        display: "代理人",
        width: 120,
        sortable: false
      }
    ];
    this.$store.dispatch("addpatent/setColumns", columns);
  }

  @Watch("addPatentShowInputDialog")
  clearAddPatentData() {
    if (!this.addPatentShowInputDialog) {
      // this.addPatentSearchData.patentNo = '';
      // this.addPatentSearchData.patentee = '';
      // this.addPatentSearchData.agencyName = '';
    }
  }

  submitPatentNo() {
    const form = this.$refs.addDataForm as any;
    form.validate((isValid: boolean) => {
      if (!isValid) {
        showWarning(MSG_INVALID_PAGE);
        return;
      }
      const params = { patentNo: this.addPatentSearchData.patentNo };
      this.addPatentQueryStr = JSON.stringify(params);
      this.addPatentShowGrid = true;
      // this.addPatentShowInputDialog = false;
    });
  }

  submitPatentee() {
    const form = this.$refs.addDataForm as any;
    form.validate((isValid: boolean) => {
      if (!isValid) {
        showWarning(MSG_INVALID_PAGE);
        return;
      }
      const params: { [key: string]: any } = {};
      if (!isEmpty(this.addPatentSearchData.patentee)) {
        params.patentee = this.addPatentSearchData.patentee;
      }
      this.addPatentQueryStr = JSON.stringify(params);
      this.addPatentShowGrid = true;
      // this.addPatentShowInputDialog = false;
    });
  }

  submitAgency() {
    const form = this.$refs.addDataForm as any;
    form.validate((isValid: boolean) => {
      if (!isValid) {
        showWarning(MSG_INVALID_PAGE);
        return;
      }
      const params: { [key: string]: any } = { agencyName: this.addPatentSearchData.agencyName };
      this.addPatentQueryStr = JSON.stringify(params);
      this.addPatentShowGrid = true;
      // this.addPatentShowInputDialog = false;
    });
  }

  addSelectedPatent() {
    const selectedRows = (this.$refs.patentgrid as any).getSelectedRows();
    if (!selectedRows || !selectedRows.length) {
      showWarning(MSG_001);
      return;
    }
    const params: { [key: string]: any } = {
      addByNo: true,
      patentNo: selectedRows.join()
    };
    this.$store.dispatch("addpatent/post", {
      api: API_PATENT_MANUALADD,
      params
    }).then((taskId: string) => {
      showSuccess("系统正在自动提取您添加专利的年费数据，可能需要几分钟时间，添加完成后，您可以刷新页面后在左侧导航栏查看");
      this.$store.dispatch("patentsync/setTaskId", taskId);
      this.addPatentShowGrid = false;
      this.addPatentShowInputDialog = false;
    });
  }

  addAllPatent() {
    const params: { [key: string]: any } = {};
    if (!isEmpty(this.addPatentQueryStr)) {
      Object.assign(params, JSON.parse(this.addPatentQueryStr));
    }
    Object.assign(params, { addByNo: false });
    this.$store.dispatch("addpatent/post", {
      api: API_PATENT_MANUALADD,
      params
    }).then((taskId: string) => {
      showSuccess("添加中...，请在顶部查看添加进度");
      this.$store.dispatch("patentsync/setTaskId", taskId);
      this.addPatentShowGrid = false;
      this.addPatentShowInputDialog = false;
    });
  }

  getAddPatentTitle() {
    let title = "";
    switch (this.addPatentInputMode) {
      case "patentNo":
        title = "按申请号/公开(公告)号添加";
        break;
      case "patentee":
        title = "按专利权人添加";
        break;
      case "agencyName":
        title = "按代理机构添加";
        break;
      default:
        title = "";
        break;
    }

    return title;
  }

  // --- ADD PATENT METHOD END --- //

  openSearchPanel() {
    this.showSearch = !this.showSearch;
  }

  onOpenDiffApplicantsPatentDialog() {
    this.$store.registerModule("diffapplicantspatent", commonStore);

    const patentType = this.$store.getters["enums/getEnumsByKey"]("PatentType");
    const map1: { [key: string]: any } = {};
    if (patentType && patentType.length) {
      patentType.forEach((data: any) => {
        map1[data.enumValue] = data.label;
      });
    }
    const patentStatus = this.$store.getters["enums/getEnumsByKey"]("PatentStatus");
    const map2: { [key: string]: any } = {};
    if (patentStatus && patentStatus.length) {
      patentStatus.forEach((data: any) => {
        map2[data.enumValue] = data.label;
      });
    }
    const columns: Array<TableColumnOption> = [
      {
        prop: "patentNo",
        display: "专利号",
        width: 200,
        formatter: (data: any, column: any, value: any) => {
          return this.colFormatters.formatPatentNo(data, column, value, false);
        },
        sortable: false
      },
      {
        prop: "title",
        display: "名称",
        width: 240,
        sortable: false
      },
      {
        prop: "appDate",
        display: "申请日",
        width: 110,
        sortable: false
      },
      // {
      //   prop: "pubNo",
      //   display: "公开(公告)号",
      //   width: 130,
      //   sortable: false
      // },
      // {
      //   prop: "pubDate",
      //   display: "公开(公告)日",
      //   width: 130,
      //   sortable: false
      // },
      {
        prop: "patentStatus",
        display: "法律状态",
        width: 100,
        sortable: false,
        formatter: (data: any, column: any, value: any) => {
          return this.colFormatters.formatPatentStatus(data);
        }
      },
      {
        prop: "patentee",
        display: "专利权人",
        width: 300,
        sortable: false
      },
      {
        prop: "applicants",
        display: "申请人",
        width: 320,
        sortable: false
      },
      // {prop: 'applicantAddress', display: "地址", width: 200, sortable: false},
      // {
      //   prop: "inventors",
      //   display: "发明人",
      //   width: 200,
      //   sortable: false
      // },
      {
        prop: "agencyName",
        display: "代理机构",
        width: 240,
        sortable: false
      },
      {
        prop: "agentName",
        display: "代理人",
        width: 80,
        sortable: false
      }
    ];
    this.$store.dispatch("diffapplicantspatent/setColumns", columns);
  }

  onCloseDiffApplicantsPatentDialog() {
    this.$store.unregisterModule("diffapplicantspatent");
  }

  closeDiffApplicantsPatentDialog() {
    this.diffApplicantsPatentShowGrid = false;
  }

  closeImportDialog() {
    this.patentImportVisible = false;
    this.loadPatentTree();
    this.searchData();
    this.loadDiffApplicantsCount();
  }
}

